type User = { name: string; last_name?: string };
export function getUserName(user: User) {
    let result = user.name;

    if (user.last_name) {
        result += ` ${user.last_name}`;
    }

    return result;
}

export function getRegionalPhone() {
    return window.ENV?.regionalSettings?.phone;
}